// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup__header {
    display: flex;
    flex-direction: column;
    gap: calc(.5rem);
    align-items: center;
    max-width: 400px;
    margin: 0 auto calc(1.5rem) auto;
    text-align: center;
  }

.signup__header h1 {
      margin-bottom: 0;
    }

.signup__login-container {
    margin: calc(1.5rem) 0;
    text-align: center;
  }

.signup__instructions {
    margin: 0 0 1rem;
    text-align: center;
  }

.signup__terms {
    margin-top: 1rem;
    color: #707070;
    text-align: center;
  }

.signup .warn div {
    margin-top: calc(.25rem);
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
